import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store";
import Spinner from "../base/Spinner";
import Avatar from "../../assets/icons/user.svg";
import EachOrderRowCard from "./EachOrderRow";
import UpdateDetails from "../modalOperations/UpdateCustomerDetails";
import BaseButton from "../base/BaseButton";
import {
  fetchCustomerBookingsAction,
  fetchCustomerDetailsAction,
  fetchFilteredProfilesAction,
} from "../../store/slices/customer/action";
import ArrowUpGreen from "../../assets/icons/ArrowUpGreen.svg";
import OrganisationDashboardResult from "./OrganisationDashboardResult";
import EmptyResult from "./EmptyResult";
import { getFromSessionStorage } from "../../utils/browserStorage";
import GreenRightIcon from "../../assets/img/GreenRightIcon.svg";
import { toast } from "react-toastify";
import { getMainProfile } from "../../utils/helper";
import {
  CustomerAccount,
  CustomerProfile,
} from "../../store/slices/customer/types";
import OrganisationOrderItem from "./OrganisationOrderItem";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import GreendotDot from "../../assets/icons/GreenDotIcon.svg";
import { FilterMatchMode } from "primereact/api";
import { useNavigate } from "react-router-dom";
import { saveBeneficiaryDetails } from "../../store/slices/customer";
import AddProfileModal from "../modalOperations/AddProfile";
import { BiSearchAlt } from "react-icons/bi";

const CustomerDetails = () => {
  const [loading, setLoading] = useState(false);
  const [loadingProfiles, setLoadingProfiles] = useState(false);
  const { currentOrganisationAccount } = useAppSelector(
    (state) => state.authReducer
  );

  const { customerProfilesData } = useAppSelector(
    (state) => state.customerReducer
  );
  //   const [order, setOrder] = useState({});
  //   const [showResultItems, setShowResultItems] = useState(false);
  const headerStyle = {
    color: "#0C4654",
    fontSize: "0.875rem",
    fontWeight: "500",
    backgroundColor: "transparent",
  };
  const bodyStyle = {
    color: "#0C4654",
    fontSize: "1rem",
    fontWeight: "500",
    backgroundColor: "transparent",
  };
  let { customerId } = useParams();
  const [lazyParams, setLazyParams] = useState({
    organisationId: currentOrganisationAccount?.organisationId,
    customerId,
    first: 0,
    rows: 5,
    page: 0,
    filters: {
      global: { value: "", matchMode: FilterMatchMode.CONTAINS },
    },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const [open, setUpdateOpen] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { customerDetails, customerBookings } = useAppSelector(
    (state) => state.customerReducer
  );

  const getOrders = () => {
    if (customerBookings && customerBookings.length > 0) {
      return customerBookings.map((booking) => booking.orders).flat();
    }
  };
  const openModal = () => {
    setUpdateOpen(true);
  };

  //   const handleShowResults = (item: any) => {
  //     setShowResultItems(true);
  //     setOrder(item);
  //   };

  //   const closeShowResults = () => {
  //     setShowResultItems(false);
  //   };

  const getCustomerDetails = async () => {
    setLoading(true);

    const params = {
      organisationId: currentOrganisationAccount?.organisationId as string,
      customerId: customerId as string,
    };

    const res = await dispatch(fetchCustomerDetailsAction(params));

    if (res?.payload?.status === 200) {
      getCustomerBookings(res?.payload?.payload);
      setLoading(false);
    } else {
      toast.error("Error fetching customer details. Please try again");
      setLoading(false);
    }
  };

  const getCustomerBookings = (customer: CustomerAccount) => {
    const mainProfile = getMainProfile(customer);
    const params = {
      organisationId: currentOrganisationAccount?.organisationId as string,
      userId: mainProfile?._id as string,
    };
    dispatch(fetchCustomerBookingsAction(params));
  };

  useEffect(() => {
    getCustomerDetails();
  }, []);

  useEffect(() => {
    if (customerId) {
      loadLazyData({ ...lazyParams, customerId });
    }
  }, []);

  const loadLazyData = async (lazyParams: any) => {
    setLoadingProfiles(true);
    const { payload } = await dispatch(fetchFilteredProfilesAction(lazyParams));

    if (payload?.status == 200) {
      setLoadingProfiles(false);
    } else {
      toast.error(
        "Something went wrong while fetching customers. Pls try again"
      );
      setLoadingProfiles(false);
    }
  };

  const onPage = (event: any) => {
    setLazyParams({
      filters: lazyParams.filters,
      organisationId: lazyParams.organisationId,
      customerId,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });

    loadLazyData({
      filters: lazyParams.filters,
      organisationId: lazyParams.organisationId,
      customerId,
      first: event.first,
      rows: event.rows,
      page: event.page,
    });
  };

  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    if (e.target.value.length >= 3) {
      let _filters = { ...lazyParams.filters };
      _filters["global"].value = value;
      setGlobalFilterValue(value);
      setLazyParams({ ...lazyParams, filters: _filters });
      loadLazyData({
        ...lazyParams,
        filters: _filters,
      });
    }
    if (e.target.value === "") {
      loadLazyData({
        ...lazyParams,
        filters: {
          global: { value: "", matchMode: FilterMatchMode.CONTAINS },
        },
      });
    }
  };

  const mainProfile = getMainProfile(customerDetails);
  const orders = getOrders();

  const fullNameBodyTemplate = (rowData: any) => {
    return (
      <div className="flex justify-center items-center">
        <img
          src={GreendotDot}
          alt="green dot icon"
          className="mx-2 flex my-auto"
        />
        <p>
          {rowData?.title || ""} {rowData?.firstName} {rowData?.lastName}{" "}
        </p>
      </div>
    );
  };

  const createdAtBodyTemplate = (rowData: any) =>
    rowData?.createdAt ? (
      <div>
        <span>
          {
            new Date(rowData?.createdAt)
              .toLocaleString("en-GB", { timeZone: "UTC" })
              .split(",")[0]
          }
        </span>
      </div>
    ) : (
      "----------"
    );

  //   const orderCountBodyTemplate = (rowData: any) =>
  //     rowData?.orders ? <p>{rowData?.orders?.length}</p> : "----------";

  const genderBodyTemplate = (rowData: CustomerProfile) => {
    return <>{rowData?.gender || "---------"}</>;
  };

  const handleCreateOrder = (rowData: CustomerProfile) => {
    const { title, gender, _id, firstName, lastName, dateOfBirth } = rowData;
    dispatch(
      saveBeneficiaryDetails({
        title: title || "",
        firstName: firstName || "",
        lastName: lastName || "",
        gender: gender || "",
        dateOfBirth,
        userId: _id,
        accountId: customerDetails?._id,
        email: customerDetails?.email,
        mobile: customerDetails?.mobile,
      })
    );

    navigate("/dashboard/booking/appointment-details");
  };

  const actionBodyTemplate = (rowData: CustomerProfile) => {
    return (
      <>
        <BaseButton
          text="Create order"
          variant="primary"
          styles="px-4"
          click={() => handleCreateOrder(rowData)}
        />
      </>
    );
  };

  return (
    <>
      <AddProfileModal
        isOpen={openAddProfile}
        setOpen={setOpenAddProfile}
        accountId={customerId as string}
      />
      <UpdateDetails
        isOpen={open}
        setOpen={setUpdateOpen}
        customerDetails={mainProfile as CustomerProfile}
      />
      {loading ? (
        <Spinner spinnerText={""} styles={""} />
      ) : (
        <>
          <div className="">
            <div className=" flex text-center justify-center">
              <h1 className=" font-semibold text-center flex">Welcome</h1>
            </div>

            <div className="flex justify-between px-6 py-3">
              <BaseButton
                text="Return"
                variant="neutral"
                hasLeftIcon={true}
                styles=" !text-[#35946D] md:px-4 font-[500] xl:!px-8 px-2"
                to="/dashboard/customers"
              >
                <img
                  src={GreenRightIcon}
                  alt="download"
                  className="lg:w-[24px] w-4 mr-1 rotate-180"
                />
              </BaseButton>
              <div className="flex justify-between">
                <BaseButton
                  text="Add Profile"
                  variant="neutral"
                  hasRightIcon={true}
                  styles="!px-5 !h-10 !text-[0.875rem] mx-2"
                  click={() => setOpenAddProfile(true)}
                />
                <BaseButton
                  text="Update Info"
                  variant="neutral"
                  hasRightIcon={true}
                  styles="!px-5 !h-10 !text-[0.875rem] "
                  click={openModal}
                >
                  <img
                    src={ArrowUpGreen}
                    alt="green dot icon"
                    className="w-[15px]  rotate-180 xl:w-[20px] ml-2"
                  />
                </BaseButton>
              </div>
            </div>
            <div className="bg-[#F2F6FA] m-6 p-4">
              <div className="flex items-center  py-4 px-6">
                <img src={Avatar} alt="Avatar" />
                <div className="px-6">
                  <h3 className=" font-bold text-[#0C4654] text-md">
                    {mainProfile?.title || ""} {mainProfile?.firstName}{" "}
                    {mainProfile?.lastName}
                  </h3>
                  <p className="text-[#0C4654]">{mainProfile?.gender}</p>
                </div>
              </div>
              <div className="lg:flex md:grid md:grid-cols-2 justify-between py-4 px-6">
                <div className="my-2">
                  <p className=" text-2sm text-[#525256]">Email Address</p>
                  <h3 className=" font-bold text-[#0C4654] text-base-x">
                    {customerDetails?.email}
                  </h3>
                </div>
                <div className="my-2">
                  <p className=" text-2sm text-[#525256]">Gender</p>
                  <h3 className=" font-bold text-[#0C4654] text-base-x">
                    {mainProfile?.gender ? mainProfile?.gender : "-------"}
                  </h3>
                </div>
                <div className="my-2">
                  <p className=" text-2sm text-[#525256]">Phone Number</p>
                  <h3 className=" font-bold text-[#0C4654] text-base-x">
                    {customerDetails?.mobile
                      ? customerDetails?.mobile
                      : "-------"}
                  </h3>
                </div>
                <div className="my-2">
                  <p className=" text-2sm text-[#525256]">Date Of Birth</p>
                  <h3 className=" font-bold text-[#0C4654] text-base-x">
                    {mainProfile?.dateOfBirth
                      ? new Date(mainProfile?.dateOfBirth)
                          .toLocaleString("en-GB", {
                            timeZone: "UTC",
                          })
                          .split(",")[0]
                      : "-------"}
                  </h3>
                </div>
              </div>
              <div className="flex py-4 px-6">
                {orders && orders?.length > 0 ? (
                  <div className="w-1/4">
                    <p className=" text-2sm text-[#525256]">Last order Date</p>

                    <h3 className=" font-bold text-[#0C4654] text-base-x">
                      {orders
                        ? new Date(
                            (orders?.[orders?.length - 1] as any)?.createdAt
                          )
                            .toLocaleString("en-GB", {
                              timeZone: "UTC",
                            })
                            .split(",")[0]
                        : "-------"}
                    </h3>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </div>

            {customerProfilesData?.profiles &&
              customerProfilesData?.profiles?.length > 0 && (
                <div className=" bg-[#F2F6FA] rounded-2xl border-[#E5E9F2] border-[1.5px] m-6 p-4 mt-6">
                  <h3 className="font-bold text-[#0C4654] py-1 ">Profiles</h3>
                  <>
                    <div className="bg-[#F2F6FA] rounded px-3 text-[#0C4654]">
                      <div className="my-4 px-3">
                        <label className="relative">
                          <BiSearchAlt
                            className="textbrandColor absolute left-3 top-1"
                            size="1rem"
                          />
                          <input
                            type="text"
                            className="border p-4 pl-8 rounded-[0.5rem] w-full text-[0.875rem] font-[500] placeholder-[#767B86] focus:outline-none"
                            placeholder="Search"
                            onKeyUp={onGlobalFilterChange}
                          />
                        </label>
                      </div>
                      <div className="p-3 mt-2 rounded-[8px]">
                        <DataTable
                          value={customerProfilesData?.profiles}
                          lazy
                          paginator
                          className="h-full"
                          // header={header}
                          first={lazyParams?.first}
                          rows={lazyParams?.rows}
                          totalRecords={customerProfilesData?.total}
                          onPage={onPage}
                          // onSort={onSort}
                          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                          rowsPerPageOptions={[5, 10, 25, 50]}
                          dataKey="id"
                          rowHover
                          // sortField={sortField}
                          // sortOrder={sortOrder}
                          scrollable
                          // onSelectionChange={onSelectionChange}
                          loading={loadingProfiles}
                          selectionMode="single"
                          responsiveLayout="scroll"
                          globalFilterFields={["name", "unit"]}
                          emptyMessage="No customers found."
                          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} customers"
                        >
                          <Column
                            field="name"
                            header="Full Name"
                            body={fullNameBodyTemplate}
                            headerStyle={headerStyle}
                            style={{
                              fontWeight: "700",
                              borderBottom: "5px solid #F9FAFB",
                              textAlign: "center",
                            }}
                            bodyStyle={bodyStyle}
                          />
                          <Column
                            field="gender"
                            header="Gender"
                            headerStyle={headerStyle}
                            style={{
                              fontWeight: "700",
                              borderBottom: "5px solid #F9FAFB",
                              textAlign: "center",
                            }}
                            body={genderBodyTemplate}
                            bodyStyle={bodyStyle}
                          />
                          <Column
                            field="createdDate"
                            header="Created Date"
                            body={createdAtBodyTemplate}
                            headerStyle={headerStyle}
                            style={{
                              fontWeight: "700",
                              borderBottom: "5px solid #F9FAFB",
                            }}
                            bodyStyle={bodyStyle}
                          />
                          <Column
                            field=""
                            header="Actions"
                            body={actionBodyTemplate}
                            headerStyle={headerStyle}
                            style={{
                              fontWeight: "700",
                              borderBottom: "5px solid #F9FAFB",
                            }}
                            bodyStyle={bodyStyle}
                          />
                        </DataTable>
                      </div>
                    </div>
                  </>

                  {/* <div>
                  {orders && orders?.length > 0 ? (
                    <div>
                      {orders.map((order) => {
                        return (
                          <OrganisationOrderItem
                            order={order}
                            key={order?.uniqueId}
                          />
                        );
                      })}
                    </div>
                  ) : (
                    <></>
                  )}
                </div> */}
                </div>
              )}
          </div>
        </>
      )}
    </>
  );
};

export default CustomerDetails;
